var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LogDNA from './logdna';
const startRecording = (setRecorderState) => __awaiter(void 0, void 0, void 0, function* () {
    const logger = new LogDNA();
    try {
        const stream = yield navigator.mediaDevices.getUserMedia({ audio: true });
        setRecorderState(prevState => {
            return Object.assign(Object.assign({}, prevState), { initRecording: true, mediaStream: stream });
        });
    }
    catch (err) {
        logger.error(err);
        console.log(err);
    }
});
export default startRecording;
